// 如何使用
// 
// /App.vue
// import mixin_scan from '@/mixins/mixin_scan'
// mixins: [mixin_scan],
// 
import { mapState, mapMutations } from 'vuex'
export default {
  data() {
    return {
      scan_lastTime: '',
      scan_code: '',
      scan_result: '',
      scan_timer: null,
      scan_canLeave: false,
      scan_code_: '',
      scan_result_: '',
      waitTime1: 1000,
      waitTime2: 1000,
    }
  },
  computed: {
    ...mapState(['scan_canLeave_x']),
  },
  methods: {
    navToHandler(route, id) {
      if (this.$route.fullPath === `/${route}?oid=${id}`) {
        return
      }
      if (this.currentRoute === route) {
        this.$router.replace(`${route}?oid=${id}&scan=1`)
      } else {
        this.$router.push(`${route}?oid=${id}&scan=1`)
      }
    },
    editOrderClick(row) {
      console.log(`%crow:`, 'color: #00f;', row, row.status, row.userSelectPayType)
      // if (row.cartItems.length === 0) {
      //   return
      // }
      if (row.orderType === 3) {
        // 所有的外卖平台订单都跳转到详情
        this.navToHandler('orderDetail', row.id)
        return
      }
      switch (row.status) {
        case 4: case 7: case 9:
          this.navToHandler('calcwayFood', row.id)
          break
        case 5: case 8:
          this.navToHandler('calcwayAvg', row.id)
          break
        case 6: case 10:
          this.navToHandler('calcwayCus', row.id)
          break
        case 100:
          switch (row.userSelectPayType) {
            case 2:
              this.navToHandler('calcwayAvg', row.id)
              break;
            case 3:
              this.navToHandler('calcwayCus', row.id)
              break;
            case 4:
              this.navToHandler('calcwayFood', row.id)
              break;
            default:
              this.navToHandler('orderDetail', row.id)
              break;
          }
          break
        default:
          this.navToHandler('calcway', row.id)
          break
      }
    },
    scanWatchFun(e) {
      // console.log(`%c监听到键盘触发:`, 'color: #f0f;', e.key)
      let thisTime = new Date().getTime()
      if (!this.scan_lastTime) {
        this.scan_lastTime = thisTime
        this.scan_code = e.key
      } else {
        if (thisTime - this.scan_lastTime > this.waitTime1) {
          this.scan_code = ''
          this.scan_lastTime = ''
        } else {
          this.scan_code += e.key
          this.scan_lastTime = thisTime
        }
      }
      if (this.scan_timer) {
        clearTimeout(this.scan_timer)
      }

      // if (this.scan_code.includes('Enter')) {
      if (e.key === 'Enter') {
        console.log(`%c监听到Enter:`, 'color: #f0f;', e.key)
        this.scan_lastTime = ''
        this.waitTime2 = 0
      } else {
        this.waitTime2 = 1000
      }
      this.scan_timer = setTimeout(async () => {
        // console.log(`%c扫码源码:`, 'color: #00f;', this.scan_code)
        if (this.scan_code && this.scan_code.length > 3) {
          console.log(`%cscan_canLeave_x:`, 'color: #00f;', this.scan_canLeave_x)
          if (this.scan_canLeave_x) {

            this.scan_result = this.scan_code
              .replace(/Shift/g, '')
              .replace(/CapsLock/g, '')
              .replace(/Control/g, '')
              // .replace(/Enter/g, '')
              .replace(/Insert/g, '')
              .replace(/Delete/g, '')
              .replace(/Home/g, '')
              .replace(/End/g, '')
              .replace(/PageUp/g, '')
              .replace(/PageDown/g, '')
              .replace(/NumLock/g, '')
              .replace(/Meta/g, '')
            if (this.scan_result === '') {
              return
            }
            console.log(`%c扫码源码:`, 'color: #00f;', this.scan_code)
            console.log(`%c扫码结果:`, 'color: #00f;', this.scan_result)
            this.scan_code_ = this.scan_code
            this.scan_result_ = this.scan_result

            const REGEXP1 = new RegExp('uid=([0-9]+)', 'i')
            const FLAG1 = REGEXP1.test(this.scan_result)
            const REGEXP2 = new RegExp('([0-9]{10})')
            const FLAG2 = REGEXP2.test(this.scan_result)
            console.log(`%c是否符合uniqueCode验证:`, 'color: #00f;', FLAG1)
            console.log(`%c是否符合orderNo验证:`, 'color: #00f;', FLAG2)
            if (FLAG1 || FLAG2) {
              let result = ''
              const rD = {
                shopId: this.currentShopId,
                businessEndShow: true,
                filterCheckoutOrderItem: true,
              }
              if (FLAG1) {
                result = this.scan_result.match(REGEXP1)
                rD.uniqueCode = result[1]
              } else if (FLAG2) {
                result = this.scan_result.match(REGEXP2)
                rD.orderNo = Number(result[1])
              }
              console.log(`%crD:`, 'color: #00f;', rD)
              const _R = await this.getData('order', rD)
              console.log(`%c订单详情:`, 'color: #f0f;', _R)
              if (_R && _R.length) {
                if (this.scan_canLeave_x) {
                  this.editOrderClick(_R[0])
                // } else {
                  // this.$message.warning('请关闭页面弹框后重新扫描')
                }
              } else {
                this.$message.warning(this.$t('scan.scanFailedNotFoundOrder'))
              }
            } else {
              this.$message.warning(this.$t('scan.scanFailedScanAgain'))
            }


          // } else {
            // this.$message.warning('请关闭页面弹框后重新扫描')
          }
        }
        this.scan_lastTime = ''
        this.scan_code = ''
      }, this.waitTime2)
    },
    initScanWatch() {
      document.addEventListener('keydown', this.scanWatchFun)
    },
  },
  beforeRouteLeave(to, from, next) {
    this.scan_timer && clearTimeout(this.scan_timer)
    document.removeEventListener('keydown', this.scanWatchFun)
    next()
  },
}